import React, { Component, Fragment } from 'react';
import Breadcrumb from '../../common/breadcrumb'; 
// import CKEditors from "react-ckeditor-component";
import CKEditor from "react-ckeditor-component";
import MyDropzone from '../../common/dropzone'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Digital_add_pro extends Component {
  constructor(props) {
    super(props)
    this.state = {
      content: '',
      categories: [],
      subcategories: [],
      subcat: '',
      image: '',
      image1: '',
      image2: '',
      image3: '',
      zip: '',
      requirements: '',
      dirname: '',
      cat_id: '',
      value: '',
      price:'0',
      offerFree:false
    }
    this.getSubcategories = this.getSubcategories.bind(this)
    this.uploadFileHandler = this.uploadFileHandler.bind(this)
    this.uploadFileHandler1 = this.uploadFileHandler1.bind(this)
    this.uploadFileHandler2 = this.uploadFileHandler2.bind(this)
    this.uploadFileHandler3 = this.uploadFileHandler3.bind(this)
    this.uploadZipHandler = this.uploadZipHandler.bind(this)
    this.submitHandler = this.submitHandler.bind(this)
    this.updateContent = this.updateContent.bind(this);
    this.onChange = this.onChange.bind(this)
    this.onChangereq = this.onChangereq.bind(this)
    this.onStatusHandler = this.onStatusHandler.bind(this)
  }

  onStatusHandler(e) {
    this.setState({ value: e.target.value })
    console.log(this.state.value)
  }
  updateContent(newContent) {
    this.setState({
      content: newContent
    })
  }

  updateRequirement(newContent) {
    this.setState({
      requirements: newContent
    })
  }

  onChange(evt) {
    console.log("onChange fired with event info: ", evt);
    var newContent = evt.editor.getData();
    this.setState({
      content: newContent
    })
    console.log(this.state.content)
  }

  onChangereq(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      requirements: newContent
    })
  }

  onBlur(evt) {
    console.log("onBlur event called with event info: ", evt);
  }

  afterPaste(evt) {
    console.log("afterPaste event called with event info: ", evt);
  }

  componentDidMount() {
    if (!localStorage.getItem('userInfo')) {
      window.location.href = '/admin';
    }

    var randNum = ('dir' + Math.random(0, 9))
    var folderName = randNum.toString()
    this.setState({ dirname: folderName })
    fetch(`${process.env['REACT_APP_HOST']}/api/categories`)
      .then((response) => response.json())
      .then(result => {
        this.setState({ categories: result.categoryList });
      });
  }

  getSubcategories = (e) => {
    const catId = e;
    fetch(`${process.env['REACT_APP_HOST']}/api/subcategories/${catId}/subcat`)
      .then((response) => response.json())
      .then(result => {
        this.setState({ subcategories: result });
      });
  }

  checkPrice = (e) => {
    var price = document.getElementById('price').value;
    alert(price)
  }

  uploadFileHandler = async (e) => {
    const file = e.target.files[0]
    const formData = new FormData()
    formData.append('image', file)
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'test': this.state.dirname,
          'filename': '1'
        },
      }
      const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
      this.setState({ image: data })
    } catch (error) {
    }
  }

  uploadFileHandler1 = async (e) => {
    const file = e.target.files[0]
    const formData = new FormData()
    formData.append('image', file)
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'test': this.state.dirname,
          'filename': '1'
        },
      }
      const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
      this.setState({ image1: data })
    } catch (error) {
    }
  }

  uploadFileHandler2 = async (e) => {
    const file = e.target.files[0]
    const formData = new FormData()
    formData.append('image', file)
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'test': this.state.dirname,
          'filename': '2'
        },
      }
      const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
      this.setState({ image2: data })
    } catch (error) {
    }
  }

  uploadFileHandler3 = async (e) => {
    const file = e.target.files[0]
    const formData = new FormData()
    formData.append('image', file)
    // setUploading(true)
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'test': this.state.dirname,
          'filename': '3'
        },
      }
      const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
      this.setState({ image3: data })
      //   setUploading(false)
    } catch (error) {
      // console.error(error)
      //   setUploading(false)
    }
  }

  uploadZipHandler = async (e) => {
    const formData = new FormData()
    formData.append('image', e.target.files[0])
    // setUploading(true)
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'test': this.state.dirname,
          'filename': '4'
        },
      }
      const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)

      this.setState({ zip: data })
      //   setUploading(false)
    } catch (error) {
      console.error(error)
      //   setUploading(false)
    }
  }

  offerFree=()=>{
     this.setState({ offerFree: !this.state.offerFree})
  }


  submitHandler(e) {
    e.preventDefault();
    var mobilePlatform = 'no';
    var desktopPlatform = 'no';
    var vrPlatform = 'no';
    var threeSixtyPlatform = 'no';
    var webglPlatform = 'no';
    var featured = 'no';
    if (e.target.mobilePlatform.checked) {
      mobilePlatform = 'yes';
    }
    if (e.target.desktopPlatform.checked) {
      desktopPlatform = 'yes';
    }
    if (e.target.vrPlatform.checked) {
      vrPlatform = 'yes';
    }
    if (e.target.threeSixtyPlatform.checked) {
      threeSixtyPlatform = 'yes';
    }
    if (e.target.webglPlatform.checked) {
      webglPlatform = 'yes';
    }
    if (e.target.featured.checked) {
      featured = 'yes';
    }
    // console.log(mobilePlatform);
    const url = `${process.env['REACT_APP_HOST']}/api/products/`;
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({

        name: e.target.name.value,
        price: e.target.price.value,
        category: e.target.category.value,
        subcategory: e.target.subcategory.value,
        shortDescription: "",
        gameVersion: e.target.gameVersion.value,
        status: 0,
        description: this.state.content,
        image: this.state.image,
        image1: this.state.image1,
        image2: this.state.image2,
        image3: this.state.image3,
        zip: this.state.zip,
        requirements: this.state.requirements,
        offerPrice: e.target.offerPrice.value,
        offerFree: this.state.offerFree,
        mobilePlatform: mobilePlatform,
        desktopPlatform: desktopPlatform,
        vrPlatform: vrPlatform,
        threeSixtyPlatform: threeSixtyPlatform,
        webglPlatform: webglPlatform,
        learningOutcomes: e.target.learningOutcomes.value,
        duration: e.target.duration.value,
        modulesNo: e.target.modulesNo.value,
        dirname: this.state.dirname,
        featured: featured,
        milestone_collection: []

      }),
    };

    if(this.state.offerFree === false){
        if (Number(e.target.price.value) > Number(e.target.offerPrice.value)) {
              fetch(url, params)
                .then(response => response.json())
                .then(data => {
                  if (data.message) {
                    toast.error("Please fill all the required fields !")
                  } else {
                    toast.success("Product added successfully !")
                    setTimeout(() => {
                      this.props.history.push('/products/digital/digital-product-list');
                    }, 3000);
                  }
                  })
            } else {
              toast.error("Offer price should be less than actual price")
            }
          }else{
            fetch(url, params)
                .then(response => response.json())
                .then(data => {
                  if (data.message) {
                    toast.error("Please fill all the required fields !")
                  } else {
                    toast.success("Product added successfully !")
                    setTimeout(() => {
                      this.props.history.push('/products/digital/digital-product-list');
                    }, 3000);
                  }
                  })
          }





    // if (Number(e.target.price.value) > Number(e.target.offerPrice.value)) {
    //   fetch(url, params)
    //     .then(response => response.json())
    //     .then(data => {
    //       if (data.message) {
    //         toast.error("Please fill all the required fields !")

    //       } else {
    //         toast.success("Product added successfully !")
    //         setTimeout(() => {
    //           this.props.history.push('/products/digital/digital-product-list');
    //         }, 3000);
    //       }

    //       //   e.target.reset();
    //       //   window.location.reload();
    //       //   this.props.history.push('/products/digital/digital-product-list');
    //       // return  <Redirect  to="digital-product-list" />
    //     })
    // } else {
    //   toast.error("Offer price should be less than actual price")
    // }

  }
 

  render() {
    return (
      <Fragment>
        <Breadcrumb title="Add Products" parent="Digital" />
        <ToastContainer />
        <div className="container-fluid">
          <form method="post" onSubmit={this.submitHandler}>
            <div className="row product-adding">

              <div className="col-xl-6">
                <div className="card">
                  <div className="card-header">
                    <h5>General</h5>
                  </div>
                  <div className="card-body">
                    <div className="digital-add needs-validation">
                      <div className="form-group">
                        <label className="col-form-label pt-0"><span>*</span> Title</label>
                        <input className="form-control" name="name" id="validationCustom01" type="text" required="" />
                      </div>




                      <div className="form-group">
                      <div className="row"> 
                        <div className="col-6">
                        <label className="col-form-label pt-0"><span>*</span> Price</label>
                        </div>
                        <div className="col-6 text-right">
                        <input type="checkbox" name="offerFree" onClick={this.offerFree}></input> Make it free
                        </div>
                        </div>
                      
                        { this.state.offerFree === false ?
                        <input className="form-control" id="price" name="price" type="number" onChange={(e) => this.setState({ price:e.target.value })} required="" />
                         :
                        <input className="form-control" id="price" name="price" type="number" value="0"  disabled />
                        }
                      </div>

                      <div className="form-group">
                        <label className="col-form-label pt-0"><span>*</span> Offer Price</label>
                        {/* <label className="col-form-label pt-0"><span>*</span> Offer Price</label> */}
                        { this.state.offerFree === false ?
                        <input className="form-control" name="offerPrice" id="validationCustom02" type="number" required=""></input>
                        :
                        <input className="form-control" name="offerPrice" id="validationCustom02" type="number" value=""  disabled></input>
                        }
                      </div>




                      <div className="form-group">
                        <label className="col-form-label"><span>*</span> Categories</label>
                        <select className="custom-select" name="category" required="" onChange={(e) => this.getSubcategories(e.target.value)} >
                          <option value="">--Select--</option>
                          {this.state.categories.map(category => (
                            <option value={category.id} >{category.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group" id="subcategory" >
                        <label className="col-form-label"><span>*</span> Subcategories</label>
                        <select className="custom-select" name="subcategory" required="" onChange={(e) => this.setState({ subcat: e.target.value })} >
                          <option value="">--Select--</option>
                          {
                            this.state.subcategories.map(subcat => (
                              <option value={subcat._id} >{subcat.name}</option>
                            ))
                          }
                        </select>
                      </div>

                      {/* <div className="form-group">
                        <label className="col-form-label">Short Description</label>
                        <textarea name="shortDescription" style={{ resize: 'none' }} rows="4" cols="12"></textarea>
                      </div> */}
                      <div className="form-group">
                        <label className="col-form-label"><span>*</span> Game Version</label>
                        <input className="form-control" name="gameVersion" id="validationCustom02" type="text" required="" />
                      </div>


                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h5>Add Requirements</h5>
                  </div>
                  <div className="card-body">
                    <div className="digital-add needs-validation">
                      <div className="form-group mb-0">
                        <div className="description-sm" >
                          <CKEditor

                            activeClass="p10"
                            content={this.state.requirements}
                            events={{
                              "blur": this.onBlur,
                              "afterPaste": this.afterPaste,
                              "change": this.onChangereq
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="card">
                  <div className="card-header">
                    <h5>Add Description</h5>
                  </div>
                  <div className="card-body">
                    <div className="digital-add needs-validation">
                      <div className="form-group mb-0">
                        <div className="description-sm">
                          <CKEditor
                            activeClass="p10"
                            content={this.state.content}
                            events={{
                              "blur": this.onBlur,
                              "afterPaste": this.afterPaste,
                              "change": this.onChange
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h5>Product Info</h5>
                  </div>
                  <div className="card-body">
                    <div className="digital-add needs-validation">

                      <div className="form-group">
                        {/* <label className="col-form-label">Mobile Platform </label> */}
                        <input type="checkbox" name="mobilePlatform" ></input> Mobile Platform
                      </div>
                      <div className="form-group">
                        <input type="checkbox" name="desktopPlatform"  ></input> Desktop Platform
                      </div>
                      <div className="form-group">
                        {/* <label className="col-form-label">VR Platform </label> */}
                        <input type="checkbox" name="vrPlatform"></input> VR Platform
                      </div>
                      <div className="form-group">
                        <input type="checkbox" name="threeSixtyPlatform" ></input> 360 Platform
                      </div>
                      <div className="form-group">
                        <input type="checkbox" name="webglPlatform" ></input> WebGL Platform
                      </div>
                      <div className="form-group">
                        <label className="col-form-label"><span>*</span> Learning Outcomes</label>
                        <textarea className="form-control" name="learningOutcomes" id="validationCustom02" type="text" required="" />
                      </div>
                      <div className="form-group">
                        <label className="col-form-label"><span>*</span> Duration</label>
                        <input className="form-control" name="duration" id="validationCustom02" type="text" required="" />
                      </div>
                      <div className="form-group">
                        <label className="col-form-label"><span>*</span> No of Modules / Milestone</label>
                        <input className="form-control" name="modulesNo" id="validationCustom02" type="number" required="" />
                      </div>
                      <div className="form-group">
                        <input type="checkbox" name="featured" ></input> Featured Product
                      </div>
                      <div className="form-group mb-0">
                        <div className="product-buttons text-center">
                          {/* <button type="button" className="btn btn-primary">Add</button> */}
                          <input type="submit" className="btn btn-primary" name="save" value="Add" />
                          <button type="button" className="btn btn-light">Discard</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </form>
        </div>
      </Fragment>
    )
  }
}

export default Digital_add_pro
